import React, { useEffect, useRef, useState } from 'react'
import * as bie from "react-bootstrap";
import CommonFormHeading from '../../CommonUtils/CommonFormHeading';
import { ErrorMessage, Field, FieldArray, Form, FormikProvider, useFormik } from 'formik';
import { VscDiffAdded } from 'react-icons/vsc';
import { FaEdit, FaRegTrashAlt } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { failureAlert, InfoAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import Swal from 'sweetalert2';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { MdDeleteForever } from 'react-icons/md';
import allowNumbersOnly from '../../CommonUtils/CommonValidations';

export default function AfflAddClgCourseDetails() {
    const hasFetchedData = useRef(false);
    const [showtable, setShowtable] = useState(false);
    const dispatch = useDispatch();
    const [selectedCourse, setSelectedCourse] = useState(null);
    const addclgcourseValidation = Yup.object({
        intakeList: Yup.array().of(Yup.object().shape({
            courseGroupCode: Yup.string().required(ERROR_MSG).nullable(),
            courseCatId: Yup.string().required(ERROR_MSG).nullable(),
            courseId: Yup.string().required(ERROR_MSG).nullable(),
            regSelf: Yup.string().required(ERROR_MSG).nullable(),
            mediumCode: Yup.string().required(ERROR_MSG).nullable(),
            finalSanctionIntake: Yup.string().required(ERROR_MSG).nullable(),



        })),
    })
    // Submit Formik>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    const AddCourseFormik = useFormik({
        initialValues: {
            intakeList: [
                {
                    slno: "",
                    courseId: "",
                    courseGroupCode: "",
                    courseCatId: "",
                    regSelf: "",
                    mediumCode: "",
                    finalSanctionIntake: "",
                }
            ]
        },
        enableReinitialize: true,
        validationSchema: addclgcourseValidation,
        onSubmit: (values, { resetForm }) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveIntakeDetails`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetClgIntake(values.collCode);
                            resetForm();
                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                    });
                }
            });
        }
    })

    // Edit Formik>>>>>>>>>>>>>>>>>>>
    const EditCourseFormik = useFormik({
        enableReinitialize: true,
        initialValues: {
            courseId: selectedCourse?.course_id || '',
            regSelf: selectedCourse?.reg_self || '',
            mediumCode: selectedCourse?.medium_code || '',
            finalSanctionIntake: selectedCourse?.final_sanction_intake || '',
            univcode: AddCourseFormik.values.univcode || '',
            collCode: selectedCourse?.college_code || '',
            slno: selectedCourse?.slno || '',
        },
        validationSchema: Yup.object({
            courseId: Yup.string().required(ERROR_MSG).nullable(),
            regSelf: Yup.string().required(ERROR_MSG).nullable(),
            mediumCode: Yup.string().required(ERROR_MSG).nullable(),
            finalSanctionIntake: Yup.string().required(ERROR_MSG).nullable()
        }),
        onSubmit: (values) => {
            const url = `${config.url.API_URL}UpdateCollCourses/${values.collCode}/${values.slno}`;

            Swal.fire({
                text: 'Are you sure you want to update?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, update it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc === "Successfully Submitted" ? "Successfully Updated" : res?.data?.sdesc);
                            setModal(false);
                            GetClgIntake(values.collCode);
                        } else {
                            failureAlert(res?.data?.sdesc || "Update failed");
                        }
                    });
                }
            });
        }
    });

    // Get University APi>>>>>>>>>>>>>>>>>>>>>>
    const [univdata, setUnivdata] = useState([]);
    function GetUniversityDetails() {
        let url = config.url.API_URL + `getUnvDetails`;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setUnivdata(res?.data?.unvDetails)

            }
            else {
                setUnivdata([]);
            }
        })
    }
    // Get College Names Api>>>>>>>>>>>>>>>>>>>>>
    const [clgcodes, setClgcodes] = useState([]);
    function GetCollegeCode(univcode) {
        if (!univcode) {
            setClgcodes([]);
            return;
        }
        let url = config.url.API_URL + `getCollegeDetails/` + univcode;
        CommonAxiosGet(url, dispatch).then((res) => {

            if (res?.data?.scode === '01') {
                setClgcodes(res?.data?.collDetails);

            }
            else {
                setClgcodes([]);
            }
        })
    }
    // const [clgcourses, setClgcourses] = useState([]);
    // function GetClgCourses(clgcode) {
    //     let url = config?.url?.API_URL + 'getCollCourses/' + clgcode;
    //     CommonAxiosGet(url, dispatch).then((res) => {
    //         if (res?.data?.scode === '01') {
    //             setClgcourses(res?.data?.collCourses);


    //         }
    //     })
    // }

    //    Get Medium APi>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> 
    const [mediumdata, setMediumdata] = useState([]);
    function GetMediumData(clgcode) {
        // if (!clgcode) {
        //     setMediumdata([]);
        //     return;
        // }
        // let url = config?.url?.API_URL + 'getMedium/' + clgcode;
        let url = config?.url?.API_URL + 'getMediumforcoursemapping';

        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setMediumdata(res?.data?.collCourseMedium)

            }
            else {
                setMediumdata([]);
            }
        })
    }

    // Get Group>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    const [clgroup, setClgroup] = useState([]);

    function GetCollegeGroup(clgcode) {
        if (!clgcode) {
            setClgroup([]);
            return;
        }
        let url = config?.url?.API_URL + 'getClgGroup/' + clgcode;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setClgroup(res?.data?.collcouresGroup)

            }
            else {
                setClgroup([]);
            }
        })
    }

    // Get colege category>>>>>>>>>>>>>>>>>>>>>>>>>>>>
    const [courseOptions, setCourseOptions] = useState({});
    function GetClgCategory(groupcode, rowIndex) {
        if (!groupcode) {
            setCourseOptions([]);
            return;
        }

        let url = config?.url?.API_URL + 'getcouresCategory/' + groupcode;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setCourseOptions(prev => ({
                    ...prev,
                    [rowIndex]: {
                        ...prev[rowIndex],
                        crscat: res?.data?.couresCategory,
                        crsname: [] // reset crsname when group/category changes
                    }
                }));
            }
        });
    }


    // Get Course name Api>>>>>>>>>>>>>>>>>>
    function Getcoursenames(groupcode, catcode, rowIndex) {
        if (!groupcode || !catcode) return;
        let url = config?.url?.API_URL + 'getClgGroupCourse/' + groupcode + "/" + catcode;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setCourseOptions(prev => ({
                    ...prev,
                    [rowIndex]: {
                        ...prev[rowIndex],
                        crsname: res?.data?.collcouresList
                    }
                }));
            }
        });
    }

    // Get Report of course Data>>>>>>>>>>>>>>>>>>>>>>>>>>
    const [clgintakedata, setClgintakedata] = useState([]);
    const [clgdtls, setClgdtls] = useState([]);
    function GetClgIntake(clgcode) {
        if (!clgcode) {
            setClgintakedata([]);
            return;
        }
        let url = config?.url?.API_URL + 'getDetailsIntake/' + clgcode;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setClgintakedata(res?.data?.intakeDetails)
                setClgdtls(res?.data?.collegeDetails);

            }
            else {
                setClgdtls([]);
            }

        })
    }

    useEffect(() => {
        if (!hasFetchedData.current) {
            GetUniversityDetails();
            hasFetchedData.current = true
        }
    }, [])
    const [coursename, setCoursename] = useState([]);

    const ReportColumns = [
        {
            Header: "S.No",
            accessor: (row, index) => index + 1,
        },

        {
            Header: "Course Group ",
            accessor: "group_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.group_name ?? '-'}</div>
            ),
        },

        {

            Header: "Course Category name",
            accessor: "course_cat_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.course_cat_name ?? '-'}</div>
            ),
        },
        // {
        //     Header: "Course Id",
        //     accessor: "course_id",
        //     Cell: ({ row }) => (
        //         <div style={{ textAlign: 'left' }}>{row?.values?.course_id ?? '-'}</div>
        //     ),
        // },
        {
            Header: "Course Name",
            accessor: "course_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.course_name ?? '-'}</div>
            ),
        },

        // {
        //     Header: "Course Category ID",
        //     accessor: "course_cat_id",
        //     Cell: ({ row }) => (
        //         <div style={{ textAlign: 'left' }}>{row?.values?.course_cat_id ?? '-'}</div>
        //     ),
        // },

        {
            Header: "Intake",
            accessor: "final_sanction_intake",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.final_sanction_intake ?? '-'}</div>
            ),
        },
        // {
        //     Header: "Is New Course",
        //     accessor: "is_new_course",
        //     Cell: ({ row }) => (
        //         <div style={{ textAlign: 'left' }}>{row?.original?.is_new_course === true
        //             ? "true"
        //             : row?.original?.is_new_course === false
        //                 ? "false"
        //                 : "-"}</div>
        //     ),
        // },
        {
            Header: "Is Renewal Course",
            accessor: "is_renewal_new",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.original?.is_renewal_new === true
                    ? "true"
                    : row?.original?.is_renewal_new === false
                        ? "false"
                        : "-"}</div>
            ),
        },

        {
            Header: " Medium",
            accessor: "mediumname",
        },

        {
            Header: "Regular/Self-Financed",
            accessor: "reg_self",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.original?.reg_self === "R"
                    ? "Regular"
                    : row?.original?.reg_self === "S"
                        ? "Self-Financed"
                        : "-"}</div>
            ),
        },
        {
            Header: " Campus Type ",
            accessor: "campus_type",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.campus_type ?? '-'}</div>
            ),
        },
        {
            Header: " Valid upto ",
            accessor: "affl_valid_upto",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.affl_valid_upto ?? '-'}</div>
            ),
        },

        {
            Header: "Edit  /  Delete",
            Cell: ({ row }) => {
                const rowData = row.original;
                return (
                    <div className="d-flex gap-2">
                        <button type='submit'
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                setModal(true);
                                setSelectedCourse(rowData);
                                setCoursename(rowData)

                            }}
                        >
                            <FaEdit size={18} />
                        </button>
                        <button type='button'
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                DeleteCourseDets(rowData.college_code, rowData?.slno);

                            }}
                        >
                            <MdDeleteForever size={20} />
                        </button>
                    </div>
                );
            }
        }

    ];
    function DeleteCourseDets(collcode, slno) {
        Swal.fire({
            title: 'Are you sure?',
            html: `Do you really want to delete this?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                let url = config.url.API_URL + `deleteCollCourse/` + collcode + `/` + slno;
                CommonAxiosPost(url, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {
                        // setReportData(res?.data?.grantEditCourses);
                        successAlert2(res?.data?.sdesc)
                        GetClgIntake(collcode)
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error!',
                            text: 'Failed to delete the course.',
                        });
                    }
                }).catch((err) => {
                    console.error("Delete error:", err);

                });
            }
        });
    }
    const [modal, setModal] = useState(false);
    function Clearcourselist() {

        AddCourseFormik.setFieldValue("intakeList", [{
            courseId: "",
            regSelf: "",
            mediumCode: "",
            finalSanctionIntake: "",
        }]);

    }
    return (
        <>
            <CommonFormHeading heading="Add College Course Details" />
            <bie.Modal
                show={modal}
                onHide={() => setModal(false)}
                style={{ marginTop: '15%' }}
                backdrop="static"
                size="xl">
                <FormikProvider value={EditCourseFormik}>
                    <Form onSubmit={EditCourseFormik.handleSubmit}>
                        <bie.Modal.Header style={{ backgroundColor: "#795A1D", color: "red" }} closeButton>
                            <bie.Modal.Title style={{
                                borderLeft: '4px solid #cf9831ff',
                                paddingLeft: '12px',
                                fontWeight: 'bold',
                                fontSize: '18px',
                                color: '#612904ff'
                            }}>

                                Edit Course for {selectedCourse?.group_name}- {selectedCourse?.course_cat_name}
                            </bie.Modal.Title>
                        </bie.Modal.Header>
                        <bie.Modal.Body>
                            <bie.Row>
                                {/* courseId */}
                                <bie.Col lg={3}>
                                    <label><b className="field-mandatory">Course Name</b></label>
                                    <Field type="text" name="courseId" className="form-control mb-2" value={coursename?.course_name} disabled>

                                    </Field>
                                    <ErrorMessage name="courseId" component="div" className="text-error" />
                                </bie.Col>

                                {/* regSelf */}
                                <bie.Col lg={3}>
                                    <label><b className="field-mandatory">Regular/Self-Financed</b></label>
                                    <Field as="select" name="regSelf" className="form-control mb-2">
                                        <option value="">--select--</option>
                                        <option value="R">Regular</option>
                                        <option value="S">Self-Financed</option>
                                    </Field>
                                    <ErrorMessage name="regSelf" component="div" className="text-error" />
                                </bie.Col>

                                {/* mediumCode */}
                                <bie.Col lg={3}>
                                    <label><b className="field-mandatory">Medium</b></label>
                                    <Field as="select" name="mediumCode" className="form-control mb-2">
                                        <option value="">--select--</option>
                                        {mediumdata?.map((m) => (
                                            <option key={m.medium_code} value={m.medium_code}>
                                                {m.name}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="mediumCode" component="div" className="text-error" />
                                </bie.Col>

                                {/* finalSanctionIntake */}
                                <bie.Col lg={3}>
                                    <label><b className="field-mandatory">Intake</b></label>
                                    <Field
                                        type="text"
                                        name="finalSanctionIntake"
                                        maxLength={9}
                                        className="form-control mb-2"
                                        onKeyPress={(e) => allowNumbersOnly(e)}
                                    />
                                    <ErrorMessage name="finalSanctionIntake" component="div" className="text-error" />
                                </bie.Col>
                            </bie.Row>

                            {/* Hidden Fields for univcode and collCode */}
                            <Field type="hidden" name="univcode" />
                            <Field type="hidden" name="collCode" />

                            <div className="text-end mt-3">
                                <button type="submit" className="btn btn-success btn-sm">
                                    Update
                                </button>
                            </div>
                        </bie.Modal.Body>
                    </Form>
                </FormikProvider>
            </bie.Modal>
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AddCourseFormik}>
                        <Form onChange={AddCourseFormik.handleChange} onSubmit={AddCourseFormik.handleSubmit} className='affl-form'>
                            <bie.Row className="px-2 mb-2 pt-0">

                                <bie.Row className="">
                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                        <label className='mb-1'>
                                            Select University:
                                        </label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} style={{ marginleft: "57px" }}>
                                        <Field as="select"
                                            className="form-control form-control-md"
                                            name="univcode"
                                            onChange={(e) => {
                                                GetCollegeCode(e?.target?.value);
                                                setShowtable(false);

                                            }}>
                                            <option value=''>--select--</option>
                                            {univdata && univdata?.map((univ, i) => (
                                                <option key={univ?.ub_code} value={univ?.ub_code}>{univ?.ub_name}</option>
                                            ))}
                                        </Field>

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2}>
                                        <label className=''>
                                            Select College Name :
                                        </label>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3}>

                                        <Field as="select"
                                            className="form-control form-control-md"
                                            name="collCode"
                                            onChange={(e) => {
                                                setShowtable(false);
                                            }}>
                                            <option value=''>--select--</option>
                                            {clgcodes && clgcodes?.map((univ, i) => (
                                                <option key={univ?.coll_code} value={univ?.coll_code}>{univ?.collname}</option>
                                            ))}
                                        </Field>
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={1} xl={1} xxl={1} >
                                        <button type="button" className="btn btn-success "
                                            onClick={() => {
                                                if (!AddCourseFormik?.values?.univcode && !AddCourseFormik?.values?.collCode) {
                                                    InfoAlert("please select University and college")
                                                }
                                                else {
                                                    GetClgIntake(AddCourseFormik?.values?.collCode);
                                                    // GetClgCourses(AddCourseFormik?.values?.collCode);
                                                    GetMediumData(AddCourseFormik?.values?.collCode);
                                                    GetCollegeGroup(AddCourseFormik?.values?.collCode)
                                                    Clearcourselist();
                                                    setShowtable(true);

                                                }

                                            }}>
                                            Get Data
                                        </button>
                                    </bie.Col>

                                    <br />
                                    <br />

                                </bie.Row>

                                {showtable === true && (<>
                                    <div className="college-container pt-3" >
                                        <div className="college-row">
                                            <div className="college-item">
                                                <span className="college-label">College Code:</span>
                                                <span className="college-value">{clgdtls[0]?.coll_code}</span>
                                            </div>
                                            <div className="college-item">
                                                <span className="college-label">University Name:</span>
                                                <span className="college-value">{clgdtls[0]?.ub_name}</span>
                                            </div>
                                        </div>

                                        <div className="college-row">
                                            <div className="college-item">
                                                <span className="college-label">Institution Name:</span>
                                                <span className="college-value">{clgdtls[0]?.inst_name}</span>
                                            </div>
                                            <div className="college-item">
                                                <span className="college-label">Mobile:</span>
                                                <span className="college-value">{clgdtls[0]?.inst_mobile}</span>
                                            </div>
                                        </div>

                                        <div className="college-row">
                                            <div className="college-item">
                                                <span className="college-label">Address:</span>
                                                <span className="college-value">{clgdtls[0]?.inst_address}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>
                                                    <th> S.No</th>
                                                    <th>Group Name</th>
                                                    <th>Course Category</th>
                                                    <th> Course Name </th>
                                                    <th>Regular/Self-Financed</th>
                                                    <th>Medium	</th>
                                                    <th>Intake </th>
                                                    <th>Action</th>


                                                </tr>
                                            </thead>
                                            <tbody>
                                                <FieldArray name="intakeList">
                                                    {(QualificationValues) => {
                                                        return QualificationValues?.form?.values?.intakeList.map((qual, index) => {
                                                            return (
                                                                <>
                                                                    <tr key={index}>
                                                                        <td>
                                                                            <center>{index + 1}</center>
                                                                        </td>

                                                                        <td>
                                                                            <Field as="select"
                                                                                name={`intakeList[${index}].courseGroupCode`}
                                                                                className="form-control form-control-md"
                                                                                //     onChange={(e) => {
                                                                                //         const value = e.target.value;
                                                                                //         AddCourseFormik.setFieldValue(`intakeList[${index}].courseGroupCode`, value);
                                                                                //         AddCourseFormik.setFieldValue(`intakeList[${index}].courseCatId`, '');
                                                                                //         AddCourseFormik.setFieldValue(`intakeList[${index}].courseId`, '');
                                                                                //         GetClgCategory(value, index);
                                                                                //     }}
                                                                                // >

                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    AddCourseFormik.setFieldValue(`intakeList[${index}].courseGroupCode`, value);
                                                                                    AddCourseFormik.setFieldValue(`intakeList[${index}].courseCatId`, '');
                                                                                    AddCourseFormik.setFieldValue(`intakeList[${index}].courseId`, '');

                                                                                    // Reset courseOptions only for this index
                                                                                    setCourseOptions(prev => ({
                                                                                        ...prev,
                                                                                        [index]: {
                                                                                            crscat: [],
                                                                                            crsname: []
                                                                                        }
                                                                                    }));

                                                                                    if (value) {
                                                                                        GetClgCategory(value, index);
                                                                                    }
                                                                                }}>

                                                                                <option value="">--select--</option>
                                                                                {clgroup.map((univ, i) => (
                                                                                    <option key={i} value={univ?.groupcode}>
                                                                                        {univ?.main_group}
                                                                                    </option>
                                                                                ))}
                                                                            </Field>
                                                                            <ErrorMessage name={`intakeList[${index}].courseGroupCode`} component="div" className="text-error" />
                                                                        </td>

                                                                        {/* Category Select */}
                                                                        <td>
                                                                            <Field as="select"
                                                                                name={`intakeList[${index}].courseCatId`}
                                                                                className="form-control form-control-md"
                                                                                // onChange={(e) => {
                                                                                //     const value = e.target.value;
                                                                                //     AddCourseFormik?.setFieldValue(`intakeList[${index}].courseCatId`, value);
                                                                                //     AddCourseFormik?.setFieldValue(`intakeList[${index}].courseId`, '');

                                                                                //     const groupVal = AddCourseFormik.values.intakeList[index].courseGroupCode;
                                                                                //     Getcoursenames(groupVal, value, index);
                                                                                // }}
                                                                                onChange={(e) => {
                                                                                    const value = e.target.value;
                                                                                    const groupVal = AddCourseFormik?.values?.intakeList[index]?.courseGroupCode;
                                                                                    AddCourseFormik.setFieldValue(`intakeList[${index}].courseCatId`, value);
                                                                                    AddCourseFormik.setFieldValue(`intakeList[${index}].courseId`, '');
                                                                                    // Reset crsname only
                                                                                    setCourseOptions(prev => ({
                                                                                        ...prev,
                                                                                        [index]: {
                                                                                            ...prev[index],
                                                                                            crsname: []
                                                                                        }
                                                                                    }));

                                                                                    if (groupVal && value) {
                                                                                        Getcoursenames(groupVal, value, index);
                                                                                    }
                                                                                }}

                                                                            >
                                                                                <option value="">--select--</option>
                                                                                {(courseOptions[index]?.crscat || []).map((univ, i) => (
                                                                                    <option key={i} value={univ?.course_cat_id}>
                                                                                        {univ?.course_cat_name}
                                                                                    </option>
                                                                                ))}
                                                                            </Field>
                                                                            <ErrorMessage name={`intakeList[${index}].courseCatId`} component="div" className="text-error" />
                                                                        </td>

                                                                        {/* Course Select */}
                                                                        <td>
                                                                            <Field name={`intakeList[${index}].courseId`}>
                                                                                {({ field, form }) => (
                                                                                    <select
                                                                                        {...field}
                                                                                        className="form-control form-control-md"
                                                                                        onChange={async (e) => {
                                                                                            const selectedValue = e.target.value;
                                                                                            const currentValues = form.values.intakeList.map(item => item.courseId);
                                                                                            const isDuplicate = currentValues.filter((id, i) => id === selectedValue && i !== index).length > 0;

                                                                                            if (isDuplicate) {
                                                                                                await Swal.fire({
                                                                                                    icon: 'error',
                                                                                                    title: 'Duplicate Course',
                                                                                                    text: 'This course is already selected in another row.',
                                                                                                });
                                                                                                form.setFieldValue(`intakeList[${index}].courseId`, '');
                                                                                                form.setFieldError(`intakeList[${index}].courseId`, 'Duplicate course selected');
                                                                                            } else {
                                                                                                form.setFieldValue(`intakeList[${index}].courseId`, selectedValue);
                                                                                                form.setFieldError(`intakeList[${index}].courseId`, '');
                                                                                            }
                                                                                        }}
                                                                                    >
                                                                                        <option value=''>--select--</option>
                                                                                        {(courseOptions[index]?.crsname || []).map((univ, i) => (
                                                                                            <option key={i} value={univ?.course_id}>{univ?.course_name}</option>
                                                                                        ))}
                                                                                    </select>
                                                                                )}
                                                                            </Field>
                                                                            <ErrorMessage name={`intakeList[${index}].courseId`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td>
                                                                            <Field as="select"
                                                                                className="form-control form-control-md"
                                                                                name={`intakeList[${index}].regSelf`}
                                                                            >
                                                                                <option value="">--select--</option>
                                                                                <option value="R">Regular</option>
                                                                                <option value="S">Self-Financed</option>
                                                                            </Field>
                                                                            <ErrorMessage name={`intakeList[${index}].regSelf`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td>
                                                                            <Field as="select" className="form-control form-control-md"
                                                                                name={`intakeList[${index}].mediumCode`}
                                                                            >
                                                                                <option value=''>--select--</option>

                                                                                {mediumdata && mediumdata?.map((rel, i) => (
                                                                                    <option value={rel?.medium_code}>{rel?.name}</option>
                                                                                ))}
                                                                            </Field>

                                                                            <ErrorMessage name={`intakeList[${index}].mediumCode`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td>
                                                                            <Field type="text" onKeyPress={(e) => allowNumbersOnly(e)} maxlength={9}
                                                                                className="form-control form-control-md"
                                                                                name={`intakeList[${index}].finalSanctionIntake`}
                                                                            />
                                                                            <ErrorMessage name={`intakeList[${index}].finalSanctionIntake`} component="div" className="text-error" />
                                                                        </td>
                                                                        <td colSpan={2} align="center" className="col-md-1">
                                                                            {index > 0 && AddCourseFormik?.values.intakeList.length > 1 ? (
                                                                                <button
                                                                                    type="button"
                                                                                    className="button-titile btn btn-sm btn-danger"
                                                                                    onClick={() => QualificationValues.remove(index)} >
                                                                                    <FaRegTrashAlt />
                                                                                </button>
                                                                            ) : <td></td>}
                                                                        </td>
                                                                    </tr >
                                                                </>
                                                            );
                                                        });
                                                    }}
                                                </FieldArray>
                                                <tr className='table-active'>
                                                    <td className='text-end' colSpan={11} >
                                                        <FieldArray name="intakeList">
                                                            {(formikFieldArray) => {
                                                                return formikFieldArray.form.values.intakeList.map((LJP, i) => {
                                                                    return (<>
                                                                        {(i === 0) ? <> <button type="button" className="button-titile btn btn-sm btn-primary btn-success"
                                                                            onClick={() => {
                                                                                formikFieldArray.push({
                                                                                    courseGroupCode: "",
                                                                                    courseCatId: "",
                                                                                    courseId: "",
                                                                                    regSelf: "",
                                                                                    mediumCode: "",
                                                                                    finalSanctionIntake: "",
                                                                                });
                                                                            }}>
                                                                            <VscDiffAdded></VscDiffAdded>
                                                                        </button> </> : ''}
                                                                    </>)
                                                                })
                                                            }}
                                                        </FieldArray>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="button-cend pt-3 mb-3">
                                        <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2'>Submit  Details</button>
                                    </div>
                                </>)}
                                {clgintakedata?.length > 0 && clgintakedata !== "No data found" && showtable === true && (<>
                                    <div className="inner-herbpage-service-title-sub mt-5">
                                        <h1 className="">Course Report</h1>
                                    </div>

                                    <div className="table-responsive mt-4">
                                        <CommonReactTable data={clgintakedata} columns={ReportColumns} filename="Add Course Details " headerName={`Add Course Details`} paginationCount="All" />
                                    </div>
                                </>
                                )}
                            </bie.Row>
                        </Form>
                    </FormikProvider>
                </bie.Container>
            </bie.Container >

        </>
    )
}
